import { i18n } from '@lingui/core';
import React from 'react';
import { CompetitorsLegend } from '../../../constants/variables';
import { ColoredItemsLegend } from '../../LegendRenderer/types/ColoredItemsLegend';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';

/**
 * Универсальный компонент динамической легенды операторов-конкурентов.
 *
 * Отображает цветные иконки только для тех операторов, которые присутствуют
 * в загруженных тайлах на текущем экране (availableOperators из Redux).
 * Не содержит переключателей — только легенда.
 *
 * Когда availableOperators пуст (тайлы ещё не загружены) — показывает всех операторов
 * из CompetitorsLegend как fallback, чтобы легенда не пустовала сразу после включения слоя.
 *
 * @param {Object}   props
 * @param {string[]} props.availableOperators - Список операторов из тайлов (значения поля в данных, напр. 'whoosh', 'yandex')
 * @param {Object}   [props.renderConfig]     - Опции рендеринга, прокидываются в ColoredItemsLegend
 * @param {Array}    [props.extraItems]       - Дополнительные элементы легенды (напр. «нет стартов»), добавляются в конец
 */
export const DynamicOperatorsLegend = ({
    availableOperators = [],
    renderConfig = {},
    extraItems = [],
}) => {
    const availableSet = new Set(availableOperators);
    // Если тайлы ещё не загружены — показываем всех как fallback
    const items = CompetitorsLegend
        .filter(({ value }) => availableSet.size === 0 || availableSet.has(value))
        .map(({ label, color }) => ({
            id: color,
            label: { id: `label_${color}`, message: i18n._(label) },
            color,
        }));
    const allItems = extraItems.length > 0 ? [ ...items, ...extraItems ] : items;

    return (
        <ColoredItemsLegend
            items={allItems}
            icon={LEGEND_ICON_TYPES.CIRCLE}
            renderConfig={{
                showIcon: true,
                iconSize: '30px',
                iconOpacity: 0.8,
                fontSize: '0.85rem',
                ...renderConfig,
            }}
        />
    );
};
